import React from 'react';
import i18next from 'i18next';
import styled from 'styled-components';
import { colors } from '../../styles/colors';

interface LoggedInAsProps {
  email: string;
}

const loggedInAs = (props: LoggedInAsProps) => {
  return (
    <>
      {props.email ? <LightText>{i18next.t('header.logInText')} </LightText> : ''} {props.email}
    </>
  );
};

const LightText = styled.span`
  color: ${colors.textLight};
  padding-right:0.4em;
`;

export default loggedInAs;